import { render, staticRenderFns } from "./AIKnowledge.vue?vue&type=template&id=26704838"
import script from "./AIKnowledge.vue?vue&type=script&lang=js"
export * from "./AIKnowledge.vue?vue&type=script&lang=js"
import style0 from "./AIKnowledge.vue?vue&type=style&index=0&id=26704838&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports